<template>
  <div class="index-box">
    <div>
      <img
        :src="detailInfo.img"
        alt="校友之家图片"
        class="recommendImg"
      />
    </div>
    
    <div class="baseInfo">
      <h3>{{ detailInfo.schoolName}}</h3>
      <div class="name">校&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;友&nbsp;：{{ detailInfo.name }}</div>
      <div class="name">联&nbsp;系&nbsp;人&nbsp;：{{ detailInfo.contact }}</div>
      <div class="name">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;点&nbsp;：{{ detailInfo.address }}</div>
      <div class="name">电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话&nbsp;：{{ detailInfo.phone }} {{ detailInfo.telephone }}</div>
      <div v-if="detailInfo.wechat" class="name">微&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;信&nbsp;：{{ detailInfo.wechat }}</div>
    </div>

    <div class="jieshao" v-html="detailInfo.content">
      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: this.$route.query.id, //校友之家Id
      detailInfo: {}, //校友之家信息
    };
  },
  created() {
    this.getHommieDetail();
  },
  methods: {
    async getHommieDetail() {
      const result = await this.$http.get("/schoolhome/detail", {
        params: { id: this.id },
      });
      this.detailInfo = result.data;
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  display: flex;
  flex-direction: column;
  image-rendering: -webkit-optimize-contrast;
  margin-left: 1.5vw;
  margin-right: 1.5vw;
  .recommendImg {
    width: 100%;
    height: 100%;
    border: 1px solid #ededed;
    border-radius: 15px;
  }
  .baseInfo {
    margin-left: 1.5vw;
    margin-right: 1.5vw;
    display: flex;
    flex-direction: column;
    .name {
      margin-top: 5px;
    }
  }
  .jieshao {
    display: flex;
    flex-direction: column;
    width: 94vw;
    min-height: 25vh;
    background: #fff;
    margin-left: 1.5vw;
    margin-right: 1.5vw;
    margin-top: 10px;
    border-radius: 10px;
    border: 1px solid #ededed;
    box-shadow: 0px 0px 10px #ffffff;
    line-height: 25px;
    text-indent: 4ch; //首行缩进
    text-align: justify; //两端对齐
    padding: 1px 1px 1px 1px; 

    .imgdiv {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 130px;
      height: 130px;
      border-radius: 50%;
      background-size: cover;
      overflow: hidden;
      margin-top: -60px;
      margin-left: 33%;
      margin-bottom: 10px;
    }
    .name {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      text-align: center;
      font-size: 1.2rem;
      font-weight: 600;
      color: #000;
      margin-bottom: 5px;
    }
    .post {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 90vw;
      margin-left: 2.5vw;
      text-align: center;
      font-size: 1.1rem;
      font-weight: 500;
      color: #676767;
      margin-bottom: 10px;
    }
    .jjTitle {
      margin-left: 2.5vw;
      font-size: 1.2rem;
      font-weight: 600;
      color: #000;
      margin-bottom: 10px;
    }
    .jianjie {
      // position: absolute;
      display: flex;
      width: 90vw;
      font-size: 1rem;
      font-weight: 500;
      line-height: 25px;
      color: #747474;
      padding: 0 1rem 0 0.7rem;
      text-indent: 4ch;
      text-align: justify;
      margin-bottom: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hommie/Detail.vue